var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23722 15.356C0.846702 15.7466 0.846708 16.3797 1.23724 16.7702C1.62776 17.1608 2.26093 17.1608 2.65145 16.7702L9.00451 10.4171L15.358 16.7706C15.7485 17.1611 16.3816 17.1611 16.7722 16.7706C17.1627 16.3801 17.1627 15.7469 16.7722 15.3564L10.4187 9.00283L16.7715 2.64991C17.162 2.25938 17.162 1.62622 16.7715 1.2357C16.381 0.845176 15.7478 0.845182 15.3573 1.23571L9.00451 7.58861L2.6521 1.23609C2.26158 0.845559 1.62841 0.845554 1.23788 1.23607C0.847356 1.6266 0.847351 2.25976 1.23787 2.65029L7.59031 9.00283L1.23722 15.356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.659415f00e5d178b216d73ca28050e60.svg";
export { ForwardRef as ReactComponent };